import { defineComponent } from "vue";
import FloatingCard from "@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue";
import TestResultModal from "@/components/Modals/TestResultModal/TestResultModal.vue";
import AlertBox from "@/components/AlertBox/AlertBox.vue";
import { useRegisterTestStore } from "@/store/RegisterTestStore";
import { mapWritableState } from "pinia";
import PositiveResultImage from "@/assets/covid/positive-result.svg";
import PositiveResultVariantImage from "@/assets/covid/positive-result-variant.svg";
import NegativeResultImage from "@/assets/covid/negative-result.svg";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";
import ThemesHelper from "@/helpers/ThemesHelper";

export default defineComponent({
  components: {
    FloatingCard,
    TestResultModal,
    AlertBox,
  },
  data() {
    return {
      registerTestStore: useRegisterTestStore(),
      positiveResultImagePath: PositiveResultImage,
      positiveResultVariantImagePath: PositiveResultVariantImage,
      negativeResultImagePath: NegativeResultImage,
      hasError: false,
      StepContent: ThemesHelper.getThemeParams("testStepFourContents"),
    };
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["canJumpNext"]),
  },
  methods: {
    showInfoModal() {
      const el: any = this.$refs["info-modal"];
      el.toggleModal(true);
      GoogleAnalyticsEvents.clickInfoMyResult();
    },
    setResultTest(result: string) {
      this.registerTestStore.resultTest = result;
      this.registerTestStore.canJumpNext = true;
      this.hasError = false;
    },
    errorValidation() {
      this.hasError = true;
      return false;
    },
    isValidStep(): boolean {
      return this.registerTestStore.resultTest != "";
    },
    setAnimationType(animationName: string) {
      setTimeout(() => {
        const baseModal: any = this.$refs["base-modal"];
        switch (animationName) {
          case "setNextDismissAnimation":
            baseModal.setNextDismissAnimation();
            break;
          case "setNextShowAnimation":
            baseModal.setNextShowAnimation();
            break;
          case "setPreviousDismissAnimation":
            baseModal.setPreviousDismissAnimation();
            break;
          case "setPreviousShowAnimation":
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    },
  },
});
